import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, switchMap } from 'rxjs';

import { GtmScriptComponent } from '~components/gtm-script/gtm-script.component';
import { environment } from '~environments/environment.development';
import { BreakpointObserverService } from '~services/breakpoint-observer.service';
import { TranslationService } from '~services/translation.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, GtmScriptComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly translationService = inject(TranslationService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly breakpointObserverService = inject(BreakpointObserverService);
  protected readonly publicGtmId: string = environment.googleGtmId;

  ngOnInit(): void {
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((event) => event instanceof NavigationEnd),
        switchMap(() => {
          const lang = this.translationService.getLanguageFromRoute();

          return this.translationService.setLanguage(lang);
        }),
      )
      .subscribe();
  }

  onResize(): void {
    this.breakpointObserverService.onResize();
  }
}
